export const colors = {
  dirtyYellow: '#01b075',
  black: '#000',
  slate: '#405360',
  grey: '#c8c9cc',
  lightGrey: '#ebebeb',
  red: '#E02020',
  orange: '#FA6400',
  green: '#6DD400',
  white: '#FFFFFF',
  labelColor: 'rgba(0,0,0,.3)',
  lightValueColor: 'rgba(0,0,0,.5)',
};
export const fontFamily = 'Roboto';
